export interface SkuValidationDto {
  skuId: number
  validationQty: number
}

export enum ePickingRouteValidationState {
  NoValidada = 2,
  Validada = 3
}

export enum ePickingRouteStates {
  Creada = 1,
  Iniciada = 2,
  Finalizada = 3
}
